import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';
import { LMFormRequestService } from '@form/services';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { LMDropdownBaseComponent } from '@field/dropdown/lm-dropdown-base.component';
import { LMKeyType } from '@app/services';

@Component({
  selector: 'lm-dropdown-soho',
  standalone: false,
  templateUrl: 'lm-dropdown-soho.component.html',
  styleUrls: [ 'lm-dropdown-soho.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMDropdownSohoComponent extends LMDropdownBaseComponent {
  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    protected element: ElementRef
  ) {
    super(
      changeDetectorRef,
      lmFormRequestService,
      lmFieldServiceAdapter,
      element
    );
  }

  doAfterViewInitStuff() {
    // need to set readonly state for initial load
    /*    if (this.dropdown) {
          this.dropdown.readonly = this.isReadOnly;
        }*/

    if (this.updateDropDownStates()) {
      this.updateStateForValue();
    }


    //LMCLIENT-34999 enterprise 4.56 prevents keyboard events triggered by function keys to bubble up,
    // added a keydown listener for the field options shortcut.
    this.element?.nativeElement?.querySelector(`select#${this.id} + .dropdown-wrapper > div.dropdown`)?.addEventListener('keydown', (event: KeyboardEvent) => {
      if (this.lmFieldServiceAdapter.lmKeyBoardShortcutService.onKeyDown(event) === LMKeyType.FIELDOPTION) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.openFieldOptions(event);
      }
    }, { capture: true });

      // Fix horizontal misalignment of dropdown popup when opened inside the flyout overlay.
      // The IDS Enterprise dropdown appends its list to <body> and positions it using the trigger's
      // getBoundingClientRect(). When inside the fixed-position flyout panel, the calculated left
      // position can be slightly off. This listener corrects the alignment after the list opens.
      if (this.element?.nativeElement?.closest('lm-sidebar-resize')) {
        const selectEl = this.element?.nativeElement?.querySelector(`select#${this.id}`);
        if (selectEl) {
          $(selectEl).on('listopened.lm-overlay-fix', () => {
            this.correctDropdownListPositionInOverlay();
          });
        }
      }
    
  }

  /**
   * Corrects the horizontal position of the dropdown-list popup when inside the flyout overlay.
   * The dropdown-list is appended to document.body and positioned absolutely. We realign its
   * left edge with the trigger element's left edge in the viewport.
   */
  private correctDropdownListPositionInOverlay(): void {
    const pseudoElem = this.element?.nativeElement?.querySelector(`select#${this.id} + .dropdown-wrapper > div.dropdown`);
    if (!pseudoElem) {
      return;
    }

    const dropdownList = document.querySelector(`.dropdown-list[data-element-id="${this.id}"]`) as HTMLElement;
    if (!dropdownList) {
      return;
    }

    const triggerRect = pseudoElem.getBoundingClientRect();
    const expectedLeft = triggerRect.left + window.scrollX;
    const currentLeft = parseFloat(dropdownList.style.left) || 0;

    // Only correct if there's a meaningful difference (more than 1px)
    if (Math.abs(expectedLeft - currentLeft) > 1) {
      dropdownList.style.left = `${expectedLeft}px`;
    }
  }
}

